import { AlertCircle, RefreshCw } from 'lucide-react'
import { useTranslation } from 'react-i18next'

interface ErrorCardProps {
  message: string
  onRetry?: () => void
}

export function ErrorCard({ message, onRetry }: ErrorCardProps) {
  const { t } = useTranslation('common')
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-error/20 bg-error/5 px-6 py-12">
      <AlertCircle className="h-10 w-10 text-error" />
      <p className="mt-3 text-center text-text-secondary">{message}</p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="mt-4 inline-flex items-center gap-2 rounded-lg bg-surface-elevated px-4 py-2 text-sm font-medium text-text-primary transition-colors hover:bg-surface-card"
        >
          <RefreshCw className="h-4 w-4" />
          {t('actions.retry')}
        </button>
      )}
    </div>
  )
}
